module.exports = __webpack_public_path__ + "static/media/mimi6.1ce35a6b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mimi6.gif
// module id = 298
// module chunks = 0